<template>
  <div class="wrapper-page">
    <div class="wrapper-bg-header">
      <!-- <div class="container">
        <h1>มาตรฐานผลิตภัณฑ์ (Product Quality)</h1>
      </div>-->
      <div class="banner-text">
        <div>แคตตาล๊อก&nbsp;</div>
        <div style="color: rgb(243, 200, 23); font-weight:700">(Catalog)</div>
      </div>
    </div>
    <div>
      <div class="container content-container-max-width">
        <img class="img-about" src="/img/about.jpg" />
        <!-- <h4>ช่องทางการชำระเงิน</h4>
        <p>ลูกค้าสามารถชำระเงินผ่านบัญชีที่อยู่ด้านล่าง หรือติดต่อสอบถามได้ที่เบอร์โทรด้านล่าง</p>
        <p>เบอร์โทรศัพท์</p>
        <ul>
          <li>02-431-2439</li>
          <li>02-431-2440</li>
          <li>02-431-2349</li>
          <li>02-431-2350</li>
          <li>02-431-2833</li>
        </ul>
        <p>เบอร์แฟ็กซ์</p>
        <ul>
          <li>02-431-2718</li>
          <li>02-431-2719</li>
        </ul> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Catalog"
};
</script>

<style scoped>
table {
  margin-top: 10px;
}

h4 {
  margin-top: 30px !important;
  font-weight: 600;
}

.img-about {
  margin: auto;
  /* margin-bottom: 30px; */
  width: 100%;
  max-width: 600px;
}

.banner-page {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
</style>